module.exports = __webpack_public_path__ + "files/8e0981b44db53f253c8007e212cb9a73.png";